import { IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonChip, IonCol, IonContent, IonFab, IonFabButton, IonFooter, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonLoading, IonMenuButton, IonModal, IonPage, IonPopover, IonRefresher, IonRefresherContent, IonRow, IonSearchbar, IonToast, IonToolbar, isPlatform, useIonAlert, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { chatbubbles, checkmarkOutline, clipboardOutline, closeOutline, ellipsisVertical, folderOutline, notifications, refresh, settingsOutline, timeOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { abrirMesa, apiPedidosCaixasGET, cadastraEquipe, listaEquipePorPerfil, requestService, urlBasePedidos } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import CaixaGeralAbrir from '../CaixaGeralAbrir/CaixaGeralAbrir';
import Notificacoes from '../Notificacoes/Notificacoes';
import './Comandas.css';

type Props = {
  closeAction: Function;
  closeActionSimple: Function;
}

const Comandas: React.FC<Props> = (props: Props) => {
  // Navigation
  const history = useHistory();

  // Alert and Toast
  const [mostartAlerta] = useIonAlert();
  const [textToast, setTextToast] = useState("");
  const [showToast, setShowToast] = useState(false);

  // Loading State
  const [showLoading, setShowLoading] = useState(false);

  // Contexts
  const { loja, setLoja } = useContext(MessageContext);
  const { notificacoes, setNotificacoes } = useContext(MessageContext);
  const [showNotificacoes, setShowNotificacoes] = useState(false);
  const { mensagens, setMensagens } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  // State: Loja
  const [lojas, setLojas] = useState<string>(loja);

  // State: Filtro e Listagem
  const [textoFiltro, setTextoFiltro] = useState<any>();

  // State: Cliente
  const [pkCliente, setPkCliente] = useState<any>();

  // Refs
  const inputRef = useRef<any>(null);

  const [ultimoCaixa, setUltimoCaixa] = useState<any>();
  const [diasAberto, setDiasAberto] = useState(0);

  const [listaClienteComanda, setListaClienteComanda] = useState<any>([]);

  const [filter, setFilter] = useState<"todas" | "livres" | "ocupadas">("todas");

  const [showModalAbrirCaixa, setShowModalAbrirCaixa] = useState(false);

  const [showPopover, setShowPopover] = useState(false);
  const [popoverEvent, setPopoverEvent] = useState(null);


  const openPopover = (e: any) => {
    e.persist();
    setPopoverEvent(e);
    setShowPopover(true);
  };

  const closePopover = () => {
    setShowPopover(false);
    setPopoverEvent(null);
  };

  useEffect(() => {
    if (ultimoCaixa?.dataAbertura) {
      const dataAbertura: any = new Date(ultimoCaixa.dataAbertura);
      const hoje: any = new Date();
      hoje.setHours(0, 0, 0, 0); // Zera as horas para comparar apenas o dia
      dataAbertura.setHours(0, 0, 0, 0); // Zera as horas na data de abertura também

      // Calcula a diferença em milissegundos e converte para dias
      const diffDias = Math.floor((hoje - dataAbertura) / (1000 * 60 * 60 * 24));

      console.log("diffDias", diffDias);

      setDiasAberto(diffDias);
    }
  }, [ultimoCaixa]);

  useIonViewDidEnter(() => {
    setEsconderMenu(false);
    setNomeMenu("Comandas");
    buscarComandas("comanda");
    carregarCaixas();
  })

  function carregarCaixas() {
    return requestService(
      apiPedidosCaixasGET.url.replace("{id}", loja.replaceAll("#", "%23")),
      {
        method: apiPedidosCaixasGET.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
      history,
      (response: any) => {
        if (response && response.Items && response.Items.length > 0) {
          setUltimoCaixa(response.Items[0]);
        }
      },
      (error: any) => {
        console.log(error);
      }
    )
  };

  async function unirListas(perfil: any) {
    let listaComandas = await buscarComandasDynamoDb(perfil);
    let listaComandasAbertas = await buscarComandasAbertasDynamoDb();

    // Se qualquer uma das listas for undefined, inicialize-a como uma lista vazia
    listaComandas = listaComandas || [];
    listaComandasAbertas = listaComandasAbertas || [];

    // Criando um mapa para listaComandasAbertas usando clienteid como chave
    let mapaComandasAbertas = new Map(listaComandasAbertas.map((item: any) => [item.clienteid, item]));

    // Unindo as listas
    let listaUnida = listaComandas.map((comanda: any) => {
      let comandaAberta: any = mapaComandasAbertas.get(comanda.pk);

      return {
        ...comanda, // Mapeia as propriedades de comanda
        ...comandaAberta // Mapeia as propriedades de comandaAberta se houver correspondência
      };
    });

    // console.log(listaUnida);

    return listaUnida;
  }

  const buscarComandas = async (perfil: any) => {
    try {
      setShowLoading(true);
      let listaComandas = await unirListas(perfil);

      setListaClienteComanda([]);
      if (Array.isArray(listaComandas) && listaComandas.length > 0) {
        let lista = (listaComandas.sort((a: any, b: any) => (a.nome.toLowerCase() > b.nome.toLowerCase()) ? 1 : -1))

        // console.log("lista", lista);
        setListaClienteComanda(lista);

      }
    } catch (error: any) {
      console.error("Ocorreu um problema inesperado. Por favor, tente novamente mais tarde. Detalhes do erro: ", error);
      setTextToast(error);
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }

  }

  const buscarComandasDynamoDb = async (perfil: any) => {

    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    let montarUrl = listaEquipePorPerfil.url.replace("{loja}", loja.replaceAll(/#/g, "%23")).concat("?status=ativo&lojas=" + Buffer.from(loja).toString('base64'));


    const resp = await fetch(montarUrl.replace("{perfil}", perfil),
      {
        method: "GET",
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    let comandas = await resp.json();
    if (resp.status === 400 || resp.status === 401) {
      history.replace("/login/");
    }
    else {
      if (comandas.Items) {
        if (comandas.Items) {
          if (comandas.Items.length > 0) {
            return comandas.Items;
          }
          else {





            const promises = [];

            for (let i = 1; i <= 10; i++) {
              const numeroMesa = i.toString().padStart(2, '0');
              const objectRequest = {
                cpf: "",
                dataAniversario: "",
                email: "",
                empresaMarca: "",
                endereco: "",
                interno: true,
                lojas: JSON.parse(window.localStorage.getItem("lojas") || "[]").filter((value: any) => {
                  return lojas.includes(value.empresaLojaId);
                }),
                nome: `Mesa ${numeroMesa}`,
                perfil: "comanda",
                pk: "",
                statusUsuario: "ativo",
                telefone: "55"
              };

              const promise = new Promise((resolve, reject) => {
                requestService(
                  cadastraEquipe.url,
                  {
                    method: cadastraEquipe.method,
                    headers: [["token", localStorage.getItem("token") || ""]],
                    credentials: 'include',
                    body: JSON.stringify(objectRequest)
                  },
                  history,
                  (response: any) => {
                    if (response && response.usuario) {
                      resolve(true);
                    } else {
                      resolve(false);
                    }
                  },
                  (error: any) => {
                    console.log("error", error);
                    reject(error);
                  }
                );
              });

              promises.push(promise);
            }

            Promise.all(promises)
              .then(results => {
                const algumaMesaCriada = results.some((result) => result === true);
                if (algumaMesaCriada) {
                  buscarComandas("comanda");
                }
              })
              .catch(error => {
                console.error("Erro ao cadastrar mesas:", error);
              });






          }
        }
      }
    }
  }

  const buscarComandasAbertasDynamoDb = async () => {

    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    let urlFinal = urlBasePedidos.url + "/v2/mesas/listaabertas?filtro=comandas".concat("&lojas=" + Buffer.from(loja).toString('base64'));

    const resp: Response = await fetch(urlFinal,
      {
        method: "GET",
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    let comandas = await resp.json();
    if (resp.status === 400 || resp.status === 401) {
      history.replace("/login/");
    }
    else {
      if (comandas) {
        return comandas;
      }
    }
  }

  function continuarMesa(cliente: any, novoNome: any) {

    setShowLoading(true);

    let objRequest = {
      tipo: "comandas",
      novoNome: novoNome,
      clienteid: cliente.replaceAll(/#/g, '%23'),
    };

    return requestService(abrirMesa.url.replaceAll("{id}", cliente.replaceAll(/#/g, '%23')).concat("?lojas=" + Buffer.from(loja).toString('base64')), {
      method: abrirMesa.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      body: JSON.stringify(objRequest),
      credentials: 'include'
    },
      history,
      (response: any) => {
        if (response && response.message) {
          console.log("response", response);
          history.push("comandas/produtos", { id: response.message.pk.replaceAll(/#/g, '%23') });
        }

      },
      (error: any) => {
        console.log(error);
        setTextToast(error.message);
        setShowToast(true);
      }).finally(() => {
        setShowLoading(false);
      })


  }

  function tempoAndamento(dataCadastro: any) {
    if (!dataCadastro) {
      // Se não houver dataCadastro, retorna vazio
      return "";
    }

    // Convertendo a dataCadastro para um objeto de data
    const dataCadastrada = new Date(dataCadastro);
    const agora = new Date();

    // Calcula a diferença em milissegundos
    const diferencaMs = agora.getTime() - dataCadastrada.getTime();

    // Converte para unidades de tempo
    const minutos = Math.floor(diferencaMs / 1000 / 60) % 60; // Restante dos minutos
    const horas = Math.floor(diferencaMs / 1000 / 60 / 60) % 24; // Restante das horas
    const dias = Math.floor(diferencaMs / 1000 / 60 / 60 / 24); // Total de dias

    // Formatação da saída
    let resultado = "";

    if (dias > 0) {
      resultado += `${dias} ${dias === 1 ? "dia" : "dias"}`;
      return resultado;
    }
    if (horas > 0) {
      resultado += `${dias > 0 ? ", " : ""}${horas} ${horas === 1 ? "hora" : "horas"}`;
    }
    if (minutos > 0) {
      resultado += `${dias > 0 || horas > 0 ? " e " : ""}${minutos} ${minutos === 1 ? "minuto" : "minutos"}`;
    }

    return resultado || "Agora mesmo";
  }

  function readListaComandas() {

    let listaFiltrada = textoFiltro
      ? listaClienteComanda.filter((value: any) =>
        value.nome.toLowerCase().includes(textoFiltro?.toLowerCase())
      )
      : listaClienteComanda;

    if (filter == "ocupadas") {
      listaFiltrada = listaFiltrada.filter((value: any) =>
        value.sk != ""
      )
    }

    return listaFiltrada.map((value: any, index: any) => (
      <>
        {((filter == "todas" || (value.sk && filter == "ocupadas") || (!value.sk && filter == "livres")) &&
          <IonCol sizeMd="3" size="6" key={value.id}>
            <IonCard style={{ margin: "2px", minHeight: "130px" }} disabled={!(ultimoCaixa && ultimoCaixa.status == "aberto")}
              // color={(value.clienteid ?? value.pk) == pkCliente ? "danger" : 'light'}
              button
              onClick={() => {

                console.log("value.clienteid", value.clienteid);
                console.log("value.pk", value.pk);
                setPkCliente(value.clienteid || value.pk);

                if (value.clienteid) {
                  history.push("comandas/produtos", { id: value.pk.replaceAll(/#/g, '%23') });
                }
                else {
                  if (acessos?.comandas == 'edicao') {
                    mostartAlerta({
                      backdropDismiss: false,
                      header: 'Abrir ' + (window.localStorage.getItem("nomeInternoMesaOuComanda") || "Mesa"),
                      message: `
                        <div>
                          <ion-item lines="none">
                            <ion-input id="editableTitle"></ion-input>
                          </ion-item>
                        </div>
                      `,
                      buttons: [
                        {
                          text: 'Cancelar',
                          role: 'cancel',
                          handler: () => {
                            setPkCliente("");
                          },
                        },
                        {
                          text: 'Abrir',
                          handler: async () => {
                            const inputElement: any = document.querySelector('#editableTitle');
                            const editedTitle = inputElement?.value || value.nome;
                            console.log('Título editado:', editedTitle);
                            continuarMesa(value.pk, editedTitle);
                          },
                        },
                      ],
                      onDidPresent: () => {
                        // Define o valor no input após o alerta aparecer
                        const inputElement: any = document.querySelector('#editableTitle');
                        if (inputElement) {
                          inputElement.value = value.nome;
                        }
                      },
                      onDidDismiss: () => {
                        console.log('did dismiss');
                      },
                    });
                  }
                  else {
                    setTextToast("Você não tem permissão para acessar esta funcionalidade.");
                    setShowToast(true);
                  }
                }
              }}
            >

              <IonCardContent>
                {value.sk ? (
                  <IonChip color={'danger'}>
                    <IonIcon icon={clipboardOutline} />
                    <IonLabel>Aberta</IonLabel>
                  </IonChip>
                ) : (
                  <IonChip color={'success'}>
                    <IonIcon icon={checkmarkOutline} />
                    <IonLabel>Livre</IonLabel>
                  </IonChip>
                )}
                <div>
                  <IonLabel className="ion-text-wrap">
                    <b>{value.clienteNome || value.nome}</b>
                  </IonLabel>
                </div>

                <IonLabel>
                  <p>{value.valorTotal ? `R$ ${value.valorTotal}` : 'R$ 0,00'}</p>
                </IonLabel>

                {value.dataCadastro && (
                  <div style={{ textAlign: "right", fontSize: "12px" }}>
                    <IonIcon icon={timeOutline} /> {tempoAndamento(value.dataCadastro)}
                  </div>
                )}
              </IonCardContent>
            </IonCard>
          </IonCol >
        )
        }
      </>

    ));
  }

  function doRefresh(event: any) {
    buscarComandas("comanda");
    setTimeout(() => {
      event.detail.complete();
    }, 1200);
  }

  async function closeModalNotificacoes() {
    setShowNotificacoes(false);
  }

  async function closeModalSimpleNotificacoes() {
    setShowNotificacoes(false);
  }

  async function closeModalAbrirCaixa() {
    setShowModalAbrirCaixa(false);
  }

  async function closeModalAbrirCaixaSuccess() {
    carregarCaixas();
    setShowModalAbrirCaixa(false);
  }

  return (
    <IonPage>

      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuButton></IonMenuButton>
          </IonButtons>


          <IonButtons slot="end">
            <IonButton onClick={() => { setShowNotificacoes(true); }}>
              <IonIcon slot="icon-only" icon={notifications} />
              <IonBadge id="cart-badge" color="danger">{notificacoes?.length}</IonBadge>
            </IonButton>
          </IonButtons>

          <IonButtons slot="end" hidden={acessos?.chat != 'leitura' && acessos?.chat != 'edicao'}>
            <IonButton onClick={() => { history.push("./chat"); }}>
              <IonIcon slot="icon-only" icon={chatbubbles} />
              <IonBadge id="cart-badge" color="danger">{mensagens?.length}</IonBadge>
            </IonButton>
          </IonButtons>

          <IonButtons slot="end">
            <IonButton onClick={openPopover}>
              <IonIcon slot="icon-only" icon={ellipsisVertical} />
            </IonButton>
          </IonButtons>

          <IonPopover
            isOpen={showPopover}
            event={popoverEvent}
            onDidDismiss={closePopover}
          >
            <IonList>


              <IonItem lines="none" button hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao' && !(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas")}
                onClick={() => {
                  history.push("comandas/comandashistorico"); closePopover();
                }}>
                <IonIcon icon={folderOutline} slot="start" />
                <IonLabel>Histórico</IonLabel>
              </IonItem>

              <IonItem lines="none" button
                hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'}
                onClick={() => { history.push("/empresa/configuracaomesas"); closePopover(); }}>
                <IonIcon icon={settingsOutline} slot="start" />
                <IonLabel>Configurações</IonLabel>
              </IonItem>

              <IonItem lines="none" button onClick={closePopover}>
                <IonIcon icon={closeOutline} slot="start" />
                <IonLabel>Cancelar</IonLabel>
              </IonItem>
            </IonList>
          </IonPopover>

        </IonToolbar>

        <IonToolbar>
          <IonSearchbar
            ref={inputRef}
            value={textoFiltro}
            onIonChange={(e) => {
              setTextoFiltro(e.detail.value);
            }}
            enterkeyhint="search"
            placeholder="Buscar"
          />
        </IonToolbar>
      </IonHeader>

      <IonContent>

        <IonFab vertical="top" horizontal="end" slot="fixed" hidden={isPlatform("android") || isPlatform("ios")}>
          <IonFabButton color="tertiary" onClick={() => { buscarComandas("comanda"); }} >
            <IonIcon color="light" icon={refresh}></IonIcon>
          </IonFabButton>
        </IonFab>
        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>


        <IonGrid>
          <IonRow>
            {readListaComandas()}
          </IonRow>
        </IonGrid>


        <IonModal isOpen={showNotificacoes} onDidDismiss={() => { setShowNotificacoes(false); }}>
          <Notificacoes closeAction={closeModalNotificacoes} closeActionSimple={closeModalSimpleNotificacoes}></Notificacoes>
        </IonModal>


        <IonModal className="small-modal" isOpen={showModalAbrirCaixa} onDidDismiss={() => { setShowModalAbrirCaixa(false); }}>
          <CaixaGeralAbrir closeAction={closeModalAbrirCaixaSuccess} closeActionSimple={closeModalAbrirCaixa}></CaixaGeralAbrir>
        </IonModal>

      </IonContent>

      <IonFooter>
        <IonToolbar color="light" hidden={ultimoCaixa?.status === "aberto" || false}>
          <IonGrid>
            <IonRow class="ion-align-items-center">

              <IonCol size="auto">
                <IonLabel>
                  <>Para começar efetuar vendas é preciso <strong>abrir o caixa</strong></>
                </IonLabel>
              </IonCol>
              <IonCol class="ion-text-right">
                <IonButton
                  disabled={acessos?.caixa != 'edicao'}
                  color="danger" size="small" onClick={async () => {
                    setShowModalAbrirCaixa(true);
                  }}>
                  Abrir Caixa
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonToolbar>


        <IonToolbar color="light" hidden={!(ultimoCaixa && ultimoCaixa.status === "aberto" && diasAberto > 0)}>
          <IonGrid>
            <IonRow class="ion-align-items-center">
              <IonCol size="auto">
                <IonLabel>
                  <>Seu caixa está <strong>{diasAberto} dia(s) aberto</strong></>
                </IonLabel>
              </IonCol>
              <IonCol class="ion-text-right">
                <IonButton color="danger" size="small" onClick={() => history.push("./caixageral")}>
                  Fechar Caixa
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonToolbar>

      </IonFooter>

      <IonToast
        isOpen={showToast}
        position="middle" //top, bottom, middle
        onDidDismiss={() => setShowToast(false)}
        message={textToast}
        duration={3000}
      />


      <IonLoading
        cssClass='my-custom-class'
        isOpen={showLoading}
        onDidDismiss={() => { setShowLoading(false); }}
        spinner='circles'
      />

    </IonPage >
  );
};

export default Comandas;